import { DICCIONARIO } from '../../../constants/Diccionario'
import { REGEX_SERIE } from '../../../constants/Regex'
import { validacionFechaMenorIgual } from '../../../utils/stringDate'
import * as validacionesRegex from '../../../utils/strings.utils'
import * as validators from '../../../utils/validaciones'

/**
 * Validaciones para campos de agregar/editar productos
 */
export const validacionesHandleChangeProducto = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'codigoProducto':
        if (!validacionesRegex.validarRegexCodigoProducto(value)) return false
        break
      case 'precioUnitario':
      case 'precioSinIVA':
      case 'iva':
        if (!validacionesRegex.validarRegexNumericoFloat2Decimales(value)) return false
        break
      case 'servicioProducto':
      case 'unidadMedida':
      case 'descripcion':
        if (!validacionesRegex.validarAlfanumericoEspacios(value)) return false
        break
      case 'impuestoDistintoAlIVA':
        if (!validacionesRegex.validarRegexNumericoFloat2Decimales(value)) return false
        break
      case 'sucursal':
      case 'sucursalFeles':
        if (!validacionesRegex.validarAlfanumericoEspacios(value)) return false
        break
      case 'codigoSucursal':
        if (!validacionesRegex.validarRegexNumericoInt(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const validacionesOnBlurProducto = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'codigoProducto':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.CODIGO_PRODUCTO)
      if (!message) message = validators.validacionMinLenght(value, message, 2)
      break
    case 'precioUnitario':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRECIO_UNITARIO)
      if (!message) message = validators.validacionNumMinimo(value, 0)
      break
    case 'precioSinIVA':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRECIO_SIN_IVA)
      if (!message) message = validators.validacionNumMinimo(value, 0)
      break
    case 'iva':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.IVA)
      if (!message) message = validators.validacionNumMinimo(value, 0)
      break
    case 'servicioProducto':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.SERVICIO_O_PRODUCTO)
      break
    case 'unidadMedida':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.UNIDAD_DE_MEDIDA)
      break
    case 'descripcion':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.DESCRIPCION_PRODUCTO)
      if (!message) message = validators.validacionMinLenght(value, message, 4)
      break
    case 'impuestoDistintoAlIVA':
      if (value) message = validators.validacionNumMinimo(value, 0)
      break
    case 'sucursal':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.SUCURSAL_FELES)
      break
    case 'sucursalFeles':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.SUCURSAL_FELES)
      break
    case 'codigoSucursal':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.CODIGO_SUCURSAL_FELES)
      if (!message) message = validators.validacionMinLenght(value, message, 2)
      break
    default:
      break
  }
  return message
}

/**
 * Validaciones adicionales para código de verificación
 */
export const validacionesCodigoHandleChangeProducto = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'code':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const validacionesCodigoOnBlurProducto = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'code':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.CODIGO_VERIFICACION)
      break
    default:
      break
  }
  return message
}

/**
 * Validaciones genéricas para sucursales de productos
 */
export const validacionesHandleChangeSucursalProducto = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'sucursal':
      case 'sucursalFeles':
        if (!validacionesRegex.validarAlfanumericoEspacios(value)) return false
        break
      case 'codigoSucursal':
        if (!validacionesRegex.validarRegexNumericoInt(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const validacionesOnBlurSucursalProducto = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'sucursal':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.SUCURSAL_FELES)
      break
    case 'sucursalFeles':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.SUCURSAL_FELES)
      break
    case 'codigoSucursal':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.CODIGO_SUCURSAL_FELES)
      if (!message) message = validators.validacionMinLenght(value, message, 2)
      break
    default:
      break
  }
  return message
}
